import { configureStore } from "@reduxjs/toolkit";
import {
	login,
	dashboard,
	addEditBox,
	boxManagementGo,
	vendorUser,
	activityLog,
	masterPortal
} from "./action"
const store = configureStore({
	reducer: {
		login,
		dashboard,
		addEditBox,
		boxManagementGo,
		vendorUser,
		activityLog,
		masterPortal
	},
})
export default store